import { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import CustomTable from '../../../../../../../Common/Table/Table';
import { Constant } from '../../../../../../../Helpers/constant';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

const Table = props => {
  const history = useHistory();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [bookingData, setBookingData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (props?.data?.length > 0) {
      const fetchColumns = [
        {
          name: 'S.No',
          width: '90px',
          wrap: true,
          selector: row => row?.serialNumber,
        },
        {
          name: 'Template Name',
          // width: '140px',
          // cell: row => row?.name,
          cell: row => (
            <span
              className="cursor-pointer text-decoration-underline"
              style={{ color: '#3577f1' }}
              onClick={() => actionBtnHandler(`VIEW`, row?.originalData)}
            >
              {row?.name}
            </span>
          ),
        },
        {
          name: 'Rule Name',
          // width: '140px',
          cell: row => row?.name,
        },
        {
          name: 'Created At',
          // width: '140px',
          cell: row => row?.created_at,
        },
      ];
      setColumns(fetchColumns);

      setBookingData(
        props?.data?.map((data, index) => {
          return {
            serialNumber: `${props?.pageNumber * props?.limit + index + 1 - props?.limit}.`,
            name: data?.name || 'NA',
            rule_name: data?.rule_name || 'NA',
            created_at: data?.created_at ? moment(new Date(`${data?.created_at}`)).format('DD-MM-YYYY, h:mm A') : 'NA',
            originalData: data,
          };
        }),
      );
    } else {
      setBookingData([]);
      setColumns([]);
    }
  }, [props?.data]);

  /* ---------------------------- ACTION HANDLER ---------------------------- */
  const actionBtnHandler = (flag, data) => {
    if (flag === `VIEW`) {
      props.actionHandler({
        templateDetails: data,
        flag: flag,
      });
    }
  };

  return (
    <>
      <Row>
        <Col xxl={12}>
          <Card>
            <CardHeader className="d-flex justify-content-between">
              <h2 className="fw-semibold card-title mb-0 flex-grow-1">All Templates</h2>
              <button type="button" className="btn btn-success waves-effect waves-light" onClick={() => history.push(`/surge/workflow`)}>
                Create Template
              </button>
            </CardHeader>

            <CardBody>
              <CustomTable
                columns={columns ?? []}
                data={bookingData ?? []}
                totalCount={props.totalCount}
                limit={props.limit}
                handleRowsPerPageChange={props.handleRowsPerPageChange}
                currentPage={props.pageNumber}
                handlePageChange={props.handlePageChange}
                indexType={Constant.INDEX_TYPE.ONE_BASED}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Table;
